<template>
  <div class="page__data_center b-page" style="padding-top: 50px; padding-left: 20px; min-height: 100vh">
    <!--    <pre>{{ $store.state.userInfo}}</pre>-->
    <div style="padding:20px 10px; overflow: hidden; background-color: transparent">
      <div style="width: 100%; padding: 40px 40px; display: flex; background-color: #fff; border-radius: 5px">
        <div>
          <div style="font-size: 15px">Số dư tài khoản</div>
          <div style="font-size: 30px; font-weight: bold; color: orangered; margin-top: 10px">
            <!--            <pre>{{ $store.state.userInfo }}</pre>-->
            {{
              $store.state.userInfo && $store.state.userInfo.store ? $store.state.userInfo.store.balance.VND_CASHBACK : 0 | currency
            }}
          </div>
        </div>
        <div style="width: 1px; background-color: #ccccd6; margin: 0 80px; padding: 20px 0">
        </div>
        <div>
          <div style="font-size: 15px">Mã tiếp thị liên kết:</div>
          <div style="font-size: 15px; font-weight: bold; margin-top: 10px">
            Gói sản phẩm Atosa Shopee Ads:
            &nbsp;
            <span style="color: #687485; font-size: 18px">{{
                affiliate_code
              }}</span>
            <el-button type="text" @click="copy_text(affiliate_code)">
              <i style="font-size: 20px;" class="el-icon-copy-document"></i>
            </el-button>
          </div>
        </div>
      </div>

      <div style="width: 100%; padding: 40px 40px; background-color: #fff; border-radius: 5px">
        <div style="display: flex">
          <div style="flex: 1">
            <h4 style="font-weight: bold">Hướng dẫn tham gia chương trình Affiate</h4>
          </div>
          <div style="flex: 1; text-align: right">
            <el-button v-if="show_guide" type="text" size="medium" @click="show_guide = false">
              <strong class="text-primary">Thu gọn</strong>
            </el-button>
            <el-button v-else type="text" size="medium" @click="show_guide = true">
              <strong class="text-primary">Mở rộng</strong>
            </el-button>
          </div>
        </div>
        <div v-if="show_guide" style="margin-top: 30px">
          <el-timeline>
            <el-timeline-item timestamp="Bước 1" placement="top">
              <el-card>
                <div style="display: flex">
                  <div style="width: 500px; padding-top: 10px">
                    <p class="strong-title">Sao chép mã Affiate của quý khách</p>
                  </div>
                  <div style="width: 500px; height: 110px; padding-left: 120px">
                    <span style="color: #687485; font-size: 18px">Mã giới thiệu: {{
                        affiliate_code
                      }}</span>
                    <el-button type="text" @click="copy_text(affiliate_code)">
                      <i style="font-size: 20px;" class="el-icon-copy-document"></i>
                    </el-button>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="Bước 2" placement="top">
              <el-card>
                <div style="display: flex">
                  <div style="width: 500px; padding-top: 10px">
                    <p class="strong-title">Gửi mã tiếp thị tới nhiều người dùng để nhận hoa hồng</p>
                  </div>
                  <div>
                    <img src="/static/img/happy-friends.avif"
                         alt="" style="width: 500px; height: 110px; object-fit: contain">
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="Bước 3" placement="top">
              <el-card>
                <div style="display: flex">
                  <div style="width: 500px; padding-top: 10px">
                    <p class="strong-title">Người dùng thanh toán dịch vụ của Atosa và điền mã giới thiệu</p>
                  </div>
                  <div>
                    <img src="/static/img/Screenshot%202024-06-13%20at%2017.48.56.png"
                         alt="" style="width: 500px; height: 110px; object-fit: contain">
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="Bước 4" placement="top">
              <el-card>
                <div style="display: flex">
                  <div style="width: 500px; padding-top: 10px">
                    <p class="strong-title">Hệ thống sẽ tính toán và cộng vào số dư quý khách khi có giao dịch gắn mã
                      tiếp thị của quý khách</p>
                  </div>
                  <div>
                    <img src="/static/img/affiliate-marketing.webp"
                         alt="" style="width: 500px; height: 110px; object-fit: contain">
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>

    <div
      style="padding: 10px; margin: 10px 10px; overflow: hidden; background-color: #fff; border-radius: 5px">
      <div style="display: flex; padding-top: 20px">
        <div style="flex: 1; display: flex; align-items: center">
          <h4 style="font-weight: bold">Lịch sử rút tiền</h4>
        </div>
        <div style="flex: 1; text-align: right">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="show_dialog.create_withdraw = true">
            Tạo yêu cầu rút tiền
          </el-button>
        </div>
      </div>
      <div style="margin-top: 30px">
        <el-table :data="withdraw_list">
          <el-table-column label="Mã yêu cầu" width="200px">
            <template slot-scope="scope">
              {{ scope.row._id }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.created_at')" width="150px">
            <template slot-scope="scope">
              {{ scope.row.created_at * 1000 | moment('DD/MM/YYYY') }}
            </template>
          </el-table-column>
          <el-table-column label="Số tiền rút" width="150px">
            <template slot-scope="scope">
              {{ scope.row.amount | currency }}
            </template>
          </el-table-column>
          <el-table-column label="Phí rút" width="150px">
            <template slot-scope="scope">
              {{ scope.row.fee | currency }}
            </template>
          </el-table-column>
          <el-table-column label="Ngân hàng" min-width="300px">
            <template slot-scope="scope">
              <div>Ngân hàng: {{ scope.row.bank_name }}</div>
              <div>Số tài khoản: {{ scope.row.bank_account_id }}</div>
              <div>Tên tài khoản: {{ scope.row.bank_account_name }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.status')" width="150px">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === -2" type="danger">Bị từ chối</el-tag>
              <el-tag v-else-if="scope.row.status === 0" type="warning">Đang chờ xử lý</el-tag>
              <el-tag v-else type="success">Đã rút tiền</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Lý do từ chối" min-width="200px">
            <template slot-scope="scope">
              {{ scope.row.rejected_reason }}
            </template>
          </el-table-column>
          <!--          <el-table-column :label="$t('base.action')" min-width="150px"></el-table-column>-->
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.create_withdraw" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong style="font-size:14px">Tạo yêu cầu rút tiền</strong>

        <div style="margin-top: 20px">
          <div style="margin-top: 20px;">
            <strong class="strong-label">Số tiền:</strong>
            <el-input v-model="form_withdraw.amount" size="mini" placeholder="Nhập số tiền" type="number"></el-input>
          </div>

          <div style="margin-top: 20px;">
            <strong class="strong-label">Ngân hàng:</strong>
            <el-select size="mini" value="" v-model="form_withdraw.bank_name" class="full-w" filterable>
              <el-option v-for="item in bank_list" :key="item.vn_name" :value="item.vn_name"
                         :label="item.vn_name"></el-option>
            </el-select>
          </div>

          <div style="margin-top: 20px;">
            <strong class="strong-label">Số tài khoản:</strong>
            <el-input v-model="form_withdraw.bank_account_id" size="mini" placeholder="Nhập số tài khoản"></el-input>
          </div>

          <div style="margin-top: 20px;">
            <strong class="strong-label">Tên tài khoản:</strong>
            <el-input v-model="form_withdraw.bank_account_name" size="mini" placeholder="Nhập tên tài khoản"></el-input>
          </div>

          <div style="margin-top: 20px;">
            <strong class="strong-label">Thông tin liên hệ (email, sđt...):</strong>
            <el-input
              type="textarea"
              :rows="4"
              placeholder="Nhập thông tin liên hệ"
              v-model="form_withdraw.contact">
            </el-input>
          </div>

          <div style="margin-top: 20px;" class="text-right">
            <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.create_withdraw"
                       @click="m__confirm_create_withdraw">{{ $t('base.confirm') }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.congrats" :close-on-click-modal="false" width="450px" :show-close="false">
      <div slot="title" style="padding:10px">
        <div>
          <img src="/static/img/happy-friends.avif" alt=""
               style="width: 100%; object-fit: cover">
        </div>

        <div
          style="margin-top: 20px; font-size: 18px; color: #666666; text-align: center; padding: 0 20px; font-weight: 600; line-height: 30px">
          Chúc mừng quý khách đã nhận được tiền hoa hồng từ mã tiếp thị. Cảm ơn quý khách đã luôn luôn tin tưởng và sử
          dụng Atosa.
        </div>
        <div
          style="margin-top: 20px; font-size: 18px; color: #666666; text-align: center; padding: 0 20px; font-weight: 600; line-height: 30px">
          Số tiền nhận được: <span style=" font-size: 18px; font-weight: 600; color: orangered">
          {{ cashback | currency }}</span>
        </div>

        <div style="margin-top: 40px; text-align: center">
          <el-button type="primary" size="mini" @click="show_dialog.congrats = false">Tôi đã xem</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import dayjs from 'dayjs'

export default {
  data() {
    return {
      affiliate_code: {
        'SHOPEE_MARKETING': '',
        'SHOPEE_MARKETING_SURVEY': '',
        'SHOPEE_ANALYSIS': '',
        'SHOPEE_ANALYSIS_SPOILER': '',
        'TIKTOK_ADS': '',
        'ATOSA_CHAT': '',
        'TIKTOK_SHOP_ANALYSIS': '',
        'SHOPEE_MARKETING_FS': '',
        'SHOPEE_MARKETING_PLAN': '',
        'DEMO_USD': 'UW35PG1Q',
        'TIKTOK_ADS_GLOBAL': '',
        'SHOPEE': ''
      },
      withdraw_list: [],
      form_withdraw: {
        amount: null,
        bank_name: null,
        bank_account_id: null,
        bank_account_name: null,
        contact: '',
        currency: 'VND_CASHBACK'
      },
      show_guide: true,
      show_dialog: {
        create_withdraw: false,
        congrats: false
      },
      loading: {create_withdraw: false},
      cashback: 500000,
      bank_list: [
        {
          'en_name': 'Visa',
          'vn_name': 'Visa',
          'bankId': '4',
          'atmBin': '4',
          'cardLength': 13,
          'shortName': 'Visa',
          'bankCode': '',
          'type': '',
          'napasSupported': true
        },
        {
          'en_name': 'MasterCard',
          'vn_name': 'MasterCard',
          'bankId': '5',
          'atmBin': '5',
          'cardLength': 16,
          'shortName': 'MasterCard',
          'bankCode': '',
          'type': '',
          'napasSupported': true
        },
        {
          'en_name': 'An Binh Commercial Joint stock  Bank',
          'vn_name': 'Ngân hàng An Bình',
          'bankId': '970425',
          'atmBin': '970425',
          'cardLength': 16,
          'shortName': 'ABBank',
          'bankCode': '323',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Asia Commercial Bank',
          'vn_name': 'Ngân hàng Á Châu',
          'bankId': '970416',
          'atmBin': '970416',
          'cardLength': 0,
          'shortName': 'ACB',
          'bankCode': '307',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vienam Bank for Agriculture and Rural Development',
          'vn_name': 'Ngân hàng NN & PTNT VN',
          'bankId': '970405',
          'atmBin': '970499',
          'cardLength': 16,
          'shortName': 'Agribank, VBARD',
          'bankCode': '204',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Baoviet Joint Stock Commercial Bank',
          'vn_name': 'Ngân hàng TMCP Bảo Việt',
          'bankId': '970438',
          'atmBin': '970438',
          'cardLength': 20,
          'shortName': 'Baoviet Bank',
          'bankCode': '359',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Bank for Investment and Development of Vietnam',
          'vn_name': 'Ngân hàng Đầu tư và Phát triển Việt Nam',
          'bankId': '970418',
          'atmBin': '970418',
          'cardLength': 16,
          'shortName': 'BIDV',
          'bankCode': '202',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Dong A Commercial Joint stock Bank',
          'vn_name': 'Ngân hàng Đông Á',
          'bankId': '970406',
          'atmBin': '970406',
          'cardLength': 16,
          'shortName': 'Dong A Bank, DAB',
          'bankCode': '304',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vietnam Export Import Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Xuất nhập khẩu Việt Nam',
          'bankId': '970431',
          'atmBin': '970431',
          'cardLength': 16,
          'shortName': 'Eximbank, EIB',
          'bankCode': '305',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Global Petro Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Dầu khí Toàn cầu',
          'bankId': '970408',
          'atmBin': '970408',
          'cardLength': 20,
          'shortName': 'GP Bank',
          'bankCode': '320',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Housing Development Bank',
          'vn_name': 'Ngân hàng Phát triển TP HCM',
          'bankId': '970437',
          'atmBin': '970437',
          'cardLength': 20,
          'shortName': 'HDBank',
          'bankCode': '321',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Hong Leong Bank Viet Nam',
          'vn_name': 'Ngân hàng Hong Leong Viet Nam',
          'bankId': '970442',
          'atmBin': '970442',
          'cardLength': 20,
          'shortName': 'HLO',
          'bankCode': '603',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Indovina Bank',
          'vn_name': 'Indovina Bank',
          'bankId': '970434',
          'atmBin': '888999',
          'cardLength': 0,
          'shortName': 'IVB',
          'bankCode': '502',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Kien Long Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Kiên Long',
          'bankId': '970452',
          'atmBin': '970452',
          'cardLength': 16,
          'shortName': 'Kienlongbank',
          'bankCode': '353',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Lien Viet Post Bank',
          'vn_name': 'Ngan hàng TMCP Bưu điện Liên Việt',
          'bankId': '970449',
          'atmBin': '970449',
          'cardLength': 0,
          'shortName': 'Lienvietbank,  LPB',
          'bankCode': '357',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Maritime Bank',
          'vn_name': 'Ngân hàng Hàng Hải Việt Nam',
          'bankId': '970426',
          'atmBin': '970426',
          'cardLength': 16,
          'shortName': 'Maritime Bank, MSB',
          'bankCode': '302',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Military Commercial Joint stock Bank',
          'vn_name': 'Ngân hàng Quân Đội',
          'bankId': '970422',
          'atmBin': '970422',
          'cardLength': 16,
          'shortName': 'MB',
          'bankCode': '311',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Nam A Commercial Joint stock Bank',
          'vn_name': 'Ngân hàng Nam Á',
          'bankId': '970428',
          'atmBin': '970428',
          'cardLength': 0,
          'shortName': 'Nam A Bank, NAB',
          'bankCode': '306',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'North Asia Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Bắc Á',
          'bankId': '970409',
          'atmBin': '970409',
          'cardLength': 0,
          'shortName': 'NASBank, NASB',
          'bankCode': '313',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'National Citizen Bank',
          'vn_name': 'Ngân hàng Quoc Dan',
          'bankId': '970419',
          'atmBin': '970419',
          'cardLength': 16,
          'shortName': 'NCB',
          'bankCode': '352',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Ocean Bank',
          'vn_name': 'Ngân hàng Đại Dương',
          'bankId': '970414',
          'atmBin': '970414',
          'cardLength': 20,
          'shortName': 'Ocean Bank',
          'bankCode': '319',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Orient Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Phương Đông',
          'bankId': '970448',
          'atmBin': '970448',
          'cardLength': 16,
          'shortName': 'Oricombank, OCB, PhuongDong Bank',
          'bankCode': '333',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Petrolimex group commercial Joint stock Bank',
          'vn_name': 'Ngân hàng Xăng dầu Petrolimex',
          'bankId': '970430',
          'atmBin': '970430',
          'cardLength': 16,
          'shortName': 'PG Bank',
          'bankCode': '341',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'PVcombank',
          'vn_name': 'NH TMCP Đại Chúng Viet Nam',
          'bankId': '970412',
          'atmBin': '970412',
          'cardLength': 16,
          'shortName': 'PVcombank',
          'bankCode': '360',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Saigon Thuong Tin Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Sài Gòn Thương Tín',
          'bankId': '970403',
          'atmBin': '970403',
          'cardLength': 16,
          'shortName': 'Sacombank',
          'bankCode': '303',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Saigon Bank for Industry and Trade',
          'vn_name': 'Ngân hàng Sài Gòn Công Thương',
          'bankId': '970400',
          'atmBin': '161087',
          'cardLength': 16,
          'shortName': 'Saigonbank',
          'bankCode': '308',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Saigon Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng TMCP Sài Gòn',
          'bankId': '970429',
          'atmBin': '970429',
          'cardLength': 16,
          'shortName': 'SCB',
          'bankCode': '334',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'South East Asia Commercial Joint stock  Bank',
          'vn_name': 'Ngân hàng TMCP Đông Nam Á',
          'bankId': '970440',
          'atmBin': '970468',
          'cardLength': 16,
          'shortName': 'SeABank',
          'bankCode': '317',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Saigon - Hanoi Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Sài Gòn - Hà Nội',
          'bankId': '970443',
          'atmBin': '970443',
          'cardLength': 16,
          'shortName': 'SHB',
          'bankCode': '348',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Shinhan Bank',
          'vn_name': 'Ngân hàng TNHH MTV Shinhan Việt Nam',
          'bankId': '970424',
          'atmBin': '970424',
          'cardLength': 0,
          'shortName': 'Shinhan Bank',
          'bankCode': '616',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vietnam Technological and Commercial Joint stock Bank',
          'vn_name': 'Ngân hàng Kỹ thương Việt Nam',
          'bankId': '970407',
          'atmBin': '970407',
          'cardLength': 16,
          'shortName': 'Techcombank, TCB',
          'bankCode': '310',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'United Oversea Bank',
          'vn_name': 'United Oversea Bank',
          'bankId': '970458',
          'atmBin': '970458',
          'cardLength': 0,
          'shortName': 'UOB',
          'bankCode': '618',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vietnam International Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Quốc tế',
          'bankId': '970441',
          'atmBin': '970441',
          'cardLength': 0,
          'shortName': 'VIBank, VIB',
          'bankCode': '314',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'VID public',
          'vn_name': 'Ngân hàng VID Public',
          'bankId': '970439',
          'atmBin': '970439',
          'cardLength': 16,
          'shortName': 'VID public',
          'bankCode': '501',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Viet A Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Việt Á',
          'bankId': '970427',
          'atmBin': '970427',
          'cardLength': 0,
          'shortName': 'VietA Bank, VAB',
          'bankCode': '355',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vietnam Thương tin Commercial Joint Stock Bank',
          'vn_name': 'Ngân hàng Việt Nam Thương Tín',
          'bankId': '970433',
          'atmBin': '970433',
          'cardLength': 16,
          'shortName': 'Vietbank',
          'bankCode': '356',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'BanViet Commercial Jont stock Bank',
          'vn_name': 'NHTMCP Bản Việt',
          'bankId': '970454',
          'atmBin': '970454',
          'cardLength': 16,
          'shortName': 'VietCapital Bank',
          'bankCode': '327',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Joint Stock Commercial Bank for Foreign Trade of Vietnam',
          'vn_name': 'Ngân hàng TMCP Ngoại Thương',
          'bankId': '970436',
          'atmBin': '970436',
          'cardLength': 0,
          'shortName': 'Vietcombank, VCB',
          'bankCode': '203',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vietnam Joint Stock Commercial Bank for Industry and Trade',
          'vn_name': 'Ngân hàng công thương Việt Nam',
          'bankId': '970415',
          'atmBin': '970415',
          'cardLength': 16,
          'shortName': 'Vietinbank',
          'bankCode': '201',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vietnam prosperity Joint stock commercial Bank',
          'vn_name': 'Ngân hàng Thương mại cổ phần Việt Nam Thịnh Vượng',
          'bankId': '970432',
          'atmBin': '970432',
          'cardLength': 16,
          'shortName': 'VPBank',
          'bankCode': '309',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'Vietnam - Russia Bank',
          'vn_name': 'Ngân hàng Liên doanh Việt Nga',
          'bankId': '970421',
          'atmBin': '970421',
          'cardLength': 16,
          'shortName': 'VRB',
          'bankCode': '505',
          'type': 'ACC',
          'napasSupported': true
        },
        {
          'en_name': 'WOORI BANK Hanoi',
          'vn_name': 'WOORI BANK Hà Nội',
          'bankId': '970457',
          'atmBin': '970457',
          'cardLength': 0,
          'shortName': 'WHHN',
          'bankCode': '624',
          'type': 'ACC',
          'napasSupported': true
        }
      ]
    }
  },

  beforeMount() {
    this.m__get_store_cashback()
    this.m__get_withdraw()
    this.m__get_store_transaction()
  },

  methods: {
    async m__get_store_cashback() {
      const response = await this.$http.get('https://api.atosa.asia/api/v1/store/cashback/ref?channels=shopee_marketing', this.cf())
      console.log(response.body)
      const found = response.body.data.applications.find(i => i.domain === 'app.atosa.asia')
      if (found) {
        const ref = response.body.data.store_refs.find(i => i.app_id === found._id)
        if (ref) this.affiliate_code = ref.code
      }
      // if (found) {
      //   this.affiliate_code
      // }
    },

    async m__get_withdraw() {
      const response = await this.$http.get('https://api.atosa.asia/api/v1/store/withdraw', this.cf())
      this.withdraw_list = response.body.data
    },

    async m__confirm_create_withdraw() {
      if (!+this.form_withdraw.amount) {
        this.ntf_w('Vui lòng nhập số tiền muốn rút')
        return
      }
      if (+this.form_withdraw.amount < 10000) {
        this.ntf_w('Số tiền muốn rút phải lớn hơn 10,000')
        return
      }
      if (+this.form_withdraw.amount > this.$store.state.userInfo.store.balance.VND_CASHBACK) {
        this.ntf_w('Số tiền bạn muốn rút quá lớn ')
        return
      }
      if (!this.form_withdraw.bank_name) {
        this.ntf_w('Vui lòng chọn ngân hàng thụ hưởng')
        return
      }
      if (!this.form_withdraw.bank_account_id) {
        this.ntf_w('Vui lòng nhập số tài khoản')
        return
      }
      if (!this.form_withdraw.bank_account_name) {
        this.ntf_w('Vui lòng nhập tên tài khoản')
        return
      }
      if (!this.form_withdraw.bank_account_name) {
        this.ntf_w('Vui lòng nhập tên tài khoản')
        return
      }
      if (!this.form_withdraw.contact) {
        this.ntf_w('Vui lòng nhập thông tin liên hệ')
        return
      }

      try {
        await this.$confirm(`Bạn có chắc chắn tạo yêu cầu rút tiền không?`, this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.create_withdraw = true
      try {
        this.form_withdraw.amount = +this.form_withdraw.amount
        await this.$http.post('https://api.atosa.asia/api/v1/store/withdraw', this.form_withdraw, this.cf())
        await this.m__get_withdraw()
        this.show_dialog.create_withdraw = false
        this.ntf_s('Gửi yêu cầu rút tiền thành công')
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.create_withdraw = false
      }
    },

    async m__get_store_transaction() {
      const start = this.dayjs().subtract(30, 'day').startOf('day').unix()
      const end = this.dayjs().endOf('day').unix()
      const url = `https://api.atosa.asia/api/v1/store/me/transaction?start=${start}&end=${end}`
      const response = await this.$http.get(url, this.cf())
      // console.log(response.body)

      for (const item of response.body.data) {
        if (item.type === 'add-money-store' && item.message.includes('Hoàn tiền')) {
          this.show_dialog.congrats = true
          this.cashback = item.extra_data ? +item.extra_data.amount : 0
          break
        }
      }
    }
  }
}
</script>

<style>
.el-timeline {
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/affilate/index.vue